/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import custom modules

import LoadMorePosts from "./modules/load-more-posts.js";
import LoadMoreProducts from "./modules/load-more-products.js";
import Swiper from "swiper/bundle";
import handleMisc from "./modules/handle-misc.js";
import handleForms from "./modules/handle-forms.js";

const ajaxurl = my_ajax_object.ajax_url;

// // Initiate the seller sortable
handleMisc();

// // Initiate the forms
handleForms();

Array.from(document.querySelectorAll(".slider-block-container")).forEach(
	(slider) => {
		const swiper = new Swiper(slider, {
			slidesPerView: 9, // Number of items to show at once
			loop: false,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				dynamicBullets: true, // Adjusts the number of pagination bullets dynamically
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			// This will make sure the slides are properly updated when resizing
			resizeObserver: true,
			breakpoints: {
				// These are examples; adjust according to your needs
				320: {
					slidesPerView: 2,
				},
				640: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 5,
				},
				1024: {
					slidesPerView: 9,
				},
			},
			on: {
				// Ensuring slides are properly calculated when Swiper is initialized
				init: function () {
					this.update();
				},
				resize: function () {
					this.update();
				},
			},
		});
	}
);

// Initialize related products swiper
if (document.querySelector('.related-products-swiper')) {
	const relatedSwiper = new Swiper('.related-products-swiper', {
		slidesPerView: 1.2,
		spaceBetween: 16,
		breakpoints: {
			480: {
				slidesPerView: 1.2,
				spaceBetween: 20,
			},
			640: {
				slidesPerView: 2,
				spaceBetween: 24,
			}
		}
	});
}

const loadmoreposts = new LoadMorePosts();
const loadmoreproducts = new LoadMoreProducts();

let body = document.body;
let windowWidth = window.innerWidth;
let vh = window.innerHeight * 0.01;
let scrollPosition = window.scrollY;
let lastScrollPosition = scrollPosition;
let scrollTimeout;
let resizeTimeout;
let mobileNavigationActive = false;

if (sectionData) {
	// true is "1" from wp
	if (sectionData.switch == "1") {
		sessionStorage.setItem("section", sectionData.current.section);
		sessionStorage.setItem("home_url", sectionData.current.section_url);
	}

	const home_url =
		sessionStorage.getItem("home_url") || sectionData.default_home_url;
	const global_section = sessionStorage.getItem("section") || "privat";

	if (home_url && global_section) {
		const topmenu = document.getElementById("menu-topmenu");
		const topmenuItems = topmenu.querySelectorAll("li");
		topmenuItems.forEach((item) => {});
		const footerLinks = document.querySelectorAll("#footer-menu-2 li");
		footerLinks.forEach((link) => {
			let showSections = link.getAttribute("data-sections") ?? "";
			if (showSections) {
				if (showSections.search(global_section) !== -1) {
					link.style.display = "block";
				}
				//console.log(showSections.includes(section));
			}
		});

		const homeLinks = document.querySelectorAll("a.home-url");
		homeLinks.forEach((link) => {
			link.href = home_url;
		});
	}
}

// Initiate the map
// initMap();

/**
 * Mobile Navigation
 */

if (windowWidth < 1005) {
	document.documentElement.style.setProperty("--vh", `${vh}px`);
}

document
	.querySelector(".main-navigation-toggle")
	.addEventListener("click", (e) => {
		e.preventDefault();

		body.classList.toggle("main-navigation-show");

		if (body.className.includes("main-navigation-show")) {
			mobileNavigationActive = true;
		} else {
			mobileNavigationActive = false;
		}
	});

// Show mega menu on hover
document
	.getElementById("site-navigation")
	.querySelectorAll(".has-submenu")
	.forEach((item) => {
		item.addEventListener("mouseenter", (e) => {
			// Removes class from all parents
			document
				.getElementById("site-navigation")
				.querySelectorAll(".nav-item")
				.forEach((item) => {
					item.classList.remove("hover");
					// Reset aria-expanded for all menu items
					const link = item.querySelector(".has-submenu");
					if (link) {
						link.setAttribute("aria-expanded", "false");
					}
				});

			// Adds class to parent
			e.target.parentNode.parentNode.classList.add("hover");
			// Set aria-expanded to true for the opened menu
			e.target.setAttribute("aria-expanded", "true");
		});
	});

// Hover-state for no-submenu items in mega menu Todo: Merge these two.
document
	.getElementById("site-navigation")
	.querySelectorAll(".no-submenu")
	.forEach((item) => {
		item.addEventListener("mouseenter", (e) => {
			// Removes class from all parents
			document
				.getElementById("site-navigation")
				.querySelectorAll(".nav-item")
				.forEach((item) => {
					item.classList.remove("hover");
				});

			// Adds class to parent
			e.target.parentNode.parentNode.classList.add("hover");
		});
	});

// SHow mega menu sub-menu on hover
document
	.getElementById("site-navigation")
	.querySelectorAll(".nav-item-sub")
	.forEach((item) => {
		item.addEventListener("mouseenter", (e) => {
			const targetId = item.getAttribute("target-id");
			const parent = item.closest(".nav-submenu");

			// Remove class from all parents
			parent.querySelectorAll(".sub-submenu").forEach((item) => {
				item.classList.remove("hover");
			});

			// Remove class from all items
			parent.querySelectorAll(".hover-nav-item").forEach((item) => {
				item.parentNode.classList.remove("hover");
			});

			// In case there is no sub-submenu
			if (
				parent.querySelector(`.sub-submenu[target-id="${targetId}"]`) !== null
			) {
				parent
					.querySelector(`.sub-submenu[target-id="${targetId}"]`)
					.classList.add("hover");
			}
			item.parentNode.classList.add("hover");
		});
	});

// Hide mega menu on mouse leave + remove hover classes
document.getElementById("site-header").addEventListener("mouseleave", (e) => {
	document
		.getElementById("site-header")
		.querySelectorAll(".nav-item")
		.forEach((item) => {
			item.classList.remove("hover");
		});

	document
		.getElementById("site-header")
		.querySelectorAll(".hover-nav-item")
		.forEach((item) => {
			item.classList.remove("hover");
		});

	// Reset aria-expanded for all menu items
	document
		.getElementById("site-header")
		.querySelectorAll(".has-submenu")
		.forEach((item) => {
			item.setAttribute("aria-expanded", "false");
		});
});

function navigateWithForm(url) {
	// Create a form element
	const form = document.createElement("form");

	// Add a timestamp to prevent caching
	// const timestampField = document.createElement("input");
	// timestampField.type = "hidden";
	// timestampField.name = "_ts";
	// timestampField.value = Date.now();
	// form.appendChild(timestampField);

	// Submit the form
	document.body.appendChild(form);
	form.submit();
}

let targetViewSelect = document.getElementById("target-view-select");
let confirmPopup = document.getElementById("confirm-target-view");
let acceptButton = document.getElementById("accept-target-view");
let declineButton = document.getElementById("decline-target-view");

if (targetViewSelect && confirmPopup && acceptButton) {
	const availableViews = new Set(["private", "uniting", "company"]);
	let selectedTargetUrl = null;
	let selectedView = "private";
	let redirectUrl = null;

	targetViewSelect.addEventListener("click", async (e) => {
		const link = e.target.closest("a");
		if (!link) return;
		e.preventDefault();

		const view =
			Array.from(availableViews).find((view) =>
				link.parentNode.classList.contains(view)
			) || "private";

		selectedTargetUrl = link.href;

		const url = link.href;

		// Add the view as a URL parameter
		selectedView = view;
		redirectUrl = new URL(url);
		redirectUrl.searchParams.set("set_view", selectedView);

		if (jQuery(".cart-count").length) {
			confirmPopup.style.display = "block";
		} else {
			// Navigate to the URL with the parameter
			window.location.href = redirectUrl.toString();
		}
	});

	declineButton.addEventListener("click", () => {
		confirmPopup.style.display = "none";
	});

	acceptButton.addEventListener("click", () => {
		// setCookie("target-view", selectedView, 7);
		confirmPopup.style.display = "none";

		// Add the view as a URL parameter
		redirectUrl.searchParams.set("set_view", selectedView);

		fetch("/wp-admin/admin-ajax.php", {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: "action=clear_woocommerce_cart",
		})
			.then((response) => response.json())
			.then(() => {
				window.location.href = redirectUrl.toString();
			})
			.catch((error) => {
				console.error("Error:", error);
				window.location.href = redirectUrl.toString();
			});
	});
}

/**
 * Mobile menu handling
 */

document
	.getElementById("mobile-navigation")
	.querySelectorAll(".nav-item")
	.forEach((item) => {
		item.addEventListener("click", (e) => {
			// If the item has a submenu
			if (item.classList.contains("has-submenu")) {
				// e.preventDefault();

				// Toggle the submenu
				const isExpanded = item.parentNode.classList.toggle("show-submenu");
				// Update aria-expanded based on toggle state
				item.setAttribute("aria-expanded", isExpanded ? "true" : "false");

				// Close all other submenus
				document
					.getElementById("mobile-navigation")
					.querySelectorAll(".nav-item")
					.forEach((otherItem) => {
						if (otherItem !== e.target) {
							otherItem.parentNode.classList.remove("show-submenu");
							otherItem.parentNode.classList.add("hide-navitem");
							if (otherItem.classList.contains("has-submenu")) {
								otherItem.setAttribute("aria-expanded", "false");
							}
						}
					});
			}
		});
	});

document.getElementById("close-mobile-navigation").onclick = function (e) {
	document.body.classList.remove("main-navigation-show");
};

/**
 * Mobile sub nav menu handling
 */

document
	.getElementById("mobile-navigation")
	.querySelectorAll(".sub-nav-item")
	.forEach((item) => {
		item.addEventListener("click", (e) => {
			// If the item has a submenu
			if (item.classList.contains("has-submenu")) {
				// e.preventDefault();

				let backBtn = item.parentNode.parentNode.querySelector(".back-button");

				backBtn.classList.add("hide");
				// Toggle the submenu
				const isExpanded = item.parentNode.classList.toggle("show-submenu");
				// Update aria-expanded based on toggle state
				item.querySelector("a").setAttribute("aria-expanded", isExpanded ? "true" : "false");

				// Close all other submenus
				document
					.getElementById("mobile-navigation")
					.querySelectorAll(".sub-nav-item")
					.forEach((otherItem) => {
						if (otherItem !== e.target) {
							otherItem.parentNode.classList.remove("show-submenu");
							otherItem.parentNode.classList.add("hide-navitem");
							if (otherItem.classList.contains("has-submenu")) {
								const link = otherItem.querySelector("a");
								if (link) {
									link.setAttribute("aria-expanded", "false");
								}
							}
						}
					});
			}
		});
	});

/**
 * Mobile back button handling
 */

document
	.getElementById("mobile-navigation")
	.querySelectorAll(".back-button")
	.forEach((item) => {
		item.addEventListener("click", (e) => {
			let level = item.attributes["level"].value;
			if (level == 1) {
				item
					.closest("#mobile-navigation")
					.querySelectorAll(".nav-item-parent")
					.forEach((item) => {
						item.classList.remove("show-submenu");
						item.classList.remove("hide-navitem");
					});
			} else if (level == 2) {
				item
					.closest("#mobile-navigation")
					.querySelectorAll(".sub-nav-item-parent")
					.forEach((item) => {
						item.classList.remove("show-submenu");
						item.classList.remove("hide-navitem");
						item
							.closest(".nav-submenu")
							.querySelectorAll(".back-button")
							.forEach((item) => {
								item.classList.remove("hide");
							});
					});
			}
		});
	});

/**
 * Scroll event
 */

window.addEventListener("scroll", () => {
	if (scrollTimeout) {
		window.cancelAnimationFrame(scrollTimeout);
	}

	scrollTimeout = window.requestAnimationFrame(function () {
		body = document.body;
		scrollPosition = window.scrollY;

		body.classList.add("scrolling");

		if (scrollPosition > 0) {
			if (scrollPosition > lastScrollPosition) {
				body.classList.remove("scrolling-up");
				body.classList.add("scrolling-down");
			} else {
				body.classList.remove("scrolling-down");
				body.classList.add("scrolling-up");
			}
		} else {
			body.classList.remove("scrolling");
			body.classList.remove("scrolling-down");
			body.classList.remove("scrolling-up");
		}

		lastScrollPosition = scrollPosition <= 0 ? 0 : scrollPosition;
	});
});

/**
 * Resize event
 */
window.addEventListener("resize", () => {
	if (resizeTimeout) {
		window.cancelAnimationFrame(resizeTimeout);
	}

	resizeTimeout = window.requestAnimationFrame(function () {
		windowWidth = window.innerWidth;
		vh = window.innerHeight * 0.01;

		if (windowWidth < 1005) {
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		} else {
			document.documentElement.style.removeProperty("--vh");
		}

		// if (mobileNavigationActive == true) {
		// 	if (windowWidth < 1005) {
		// 		document.body.classList.add("main-navigation-show");
		// 	} else {
		// 		document.body.classList.remove("main-navigation-show");
		// 	}
		// }
	});
});

const readmoreInfo = document.querySelectorAll(".readmore-info");
if (readmoreInfo) {
	readmoreInfo.forEach((item) => {
		item.addEventListener("click", (e) => {
			e.preventDefault();
			item.parentNode.classList.toggle("show");
		});
	});
}

// Handle product gallery with navigation arrows and touch support
const galleryImages = document.querySelectorAll(".gallery-image");
const galleryThumbnails = document.querySelectorAll(".gallery-thumbnail");
const navPrevBtn = document.querySelector(".gallery-nav-prev");
const navNextBtn = document.querySelector(".gallery-nav-next");
const galleryMainContainer = document.querySelector(".product-image-main");

if (galleryImages.length > 0) {
	let currentIndex = 0;
	const totalImages = galleryImages.length;

	// Function to show image at specific index
	function showImage(index) {
		// Hide all images
		galleryImages.forEach((img) => img.classList.add("hidden"));
		// Show current image
		if (galleryImages[index]) {
			galleryImages[index].classList.remove("hidden");
		}

		// Update active thumbnail border
		galleryThumbnails.forEach((thumb) => {
			thumb.classList.remove("active", "border-dark");
			thumb.classList.add("border-transparent");
		});
		if (galleryThumbnails[index]) {
			galleryThumbnails[index].classList.add("active", "border-dark/40");
			galleryThumbnails[index].classList.remove("border-transparent");
			// Scroll thumbnail into view
			galleryThumbnails[index].scrollIntoView({
				behavior: "smooth",
				block: "nearest",
				inline: "nearest"
			});
		}

		currentIndex = index;
	}

	// Navigate to previous image
	function prevImage() {
		const newIndex = (currentIndex - 1 + totalImages) % totalImages;
		showImage(newIndex);
	}

	// Navigate to next image
	function nextImage() {
		const newIndex = (currentIndex + 1) % totalImages;
		showImage(newIndex);
	}

	// Thumbnail click handler
	galleryThumbnails.forEach((thumbnail) => {
		thumbnail.addEventListener("click", () => {
			const index = parseInt(thumbnail.getAttribute("data-index"), 10);
			if (!isNaN(index)) {
				showImage(index);
			}
		});
	});

	// Arrow navigation handlers
	if (navPrevBtn) {
		navPrevBtn.addEventListener("click", prevImage);
	}
	if (navNextBtn) {
		navNextBtn.addEventListener("click", nextImage);
	}

	// Touch/swipe support for mobile
	if (galleryMainContainer) {
		let touchStartX = 0;
		let touchEndX = 0;
		const minSwipeDistance = 50; // Minimum distance for a swipe

		galleryMainContainer.addEventListener("touchstart", (e) => {
			touchStartX = e.changedTouches[0].screenX;
		}, { passive: true });

		galleryMainContainer.addEventListener("touchend", (e) => {
			touchEndX = e.changedTouches[0].screenX;
			handleSwipe();
		}, { passive: true });

		function handleSwipe() {
			const swipeDistance = touchEndX - touchStartX;

			if (Math.abs(swipeDistance) > minSwipeDistance) {
				if (swipeDistance > 0) {
					// Swiped right - show previous
					prevImage();
				} else {
					// Swiped left - show next
					nextImage();
				}
			}
		}
	}

	// Optional: Keyboard navigation
	document.addEventListener("keydown", (e) => {
		if (e.key === "ArrowLeft") {
			prevImage();
		} else if (e.key === "ArrowRight") {
			nextImage();
		}
	});

	// Image zoom functionality
	const imageZoomModal = document.getElementById("image-zoom-modal");
	const zoomedImage = document.getElementById("zoomed-image");
	const closeZoomModalBtn = document.getElementById("close-zoom-modal");

	// Add click handler to each gallery image
	galleryImages.forEach((galleryImage) => {
		galleryImage.addEventListener("click", () => {
			// Get the image element inside the gallery-image div
			const imgElement = galleryImage.querySelector("img");
			if (imgElement) {
				// Get the full-size image URL
				const fullImageSrc = imgElement.getAttribute("src");
				const imageAlt = imgElement.getAttribute("alt") || "";

				// Set the zoomed image
				zoomedImage.setAttribute("src", fullImageSrc);
				zoomedImage.setAttribute("alt", imageAlt);

				// Show the modal
				imageZoomModal.classList.remove("hidden");
				imageZoomModal.classList.add("flex");

				// Prevent body scroll when modal is open
				document.body.style.overflow = "hidden";
			}
		});
	});

	// Close modal functionality
	function closeZoomModal() {
		imageZoomModal.classList.add("hidden");
		imageZoomModal.classList.remove("flex");
		document.body.style.overflow = "";
	}

	if (closeZoomModalBtn) {
		closeZoomModalBtn.addEventListener("click", closeZoomModal);
	}

	// Close modal when clicking on the backdrop
	if (imageZoomModal) {
		imageZoomModal.addEventListener("click", (e) => {
			if (e.target === imageZoomModal) {
				closeZoomModal();
			}
		});
	}

	// Close modal with Escape key
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && imageZoomModal && !imageZoomModal.classList.contains("hidden")) {
			closeZoomModal();
		}
	});
}

/**
 * Handle cart
 */
const headerCartIcon = document.querySelector(".header-cart-icon");
const headerCart = document.querySelector(".cart__drawer");
let timer;

if (headerCartIcon) {
	headerCartIcon.addEventListener("mouseenter", () => {
		if (window.innerWidth < 1024) {
			return;
		}
		clearTimeout(timer); // In case the timer is still running, clear it
		headerCart.classList.add("show");
	});

	headerCartIcon.addEventListener("mouseleave", () => {
		timer = setTimeout(() => {
			headerCart.classList.remove("show");
		}, 1000); // Hold for 2 seconds
	});
}

/*
 * Handle cart quantity
 */
document
	.querySelectorAll(
		".cart__drawer__body .quantity .plus, .cart__drawer__body .quantity .minus"
	)
	.forEach((button) => {
		button.addEventListener("click", function () {
			const input = this.parentElement.querySelector('input[name="quantity"]');
			let quantity = parseInt(input.value);
			const cartItemKey = this.getAttribute("data-cart-item-key");
			const action = this.classList.contains("plus") ? "increase" : "decrease";
			const cartQuantity = this.closest(".cart__drawer__body").querySelector(
				".cart__drawer__item .cart-quantity"
			);

			if (action === "increase") {
				quantity++;
			} else if (action === "decrease" && quantity > 1) {
				quantity--;
			}

			fetch(ajaxurl, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: new URLSearchParams({
					action: "update_cart_quantity",
					cart_item_key: cartItemKey,
					quantity: quantity,
				}),
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.success) {
						input.value = quantity;
						cartQuantity.textContent = quantity;
					}
				});
		});
	});

/*
 * Handle header search
 */

const headerSearch = document.querySelector(".header-search-icon");
headerSearch.addEventListener("click", (e) => {
	let nodeElement = e.target;
	if (nodeElement.nodeName != "INPUT") {
		headerSearch.classList.toggle("active");
	}
	document.addEventListener("click", (e) => {
		if (!headerSearch.contains(e.target)) {
			headerSearch.classList.remove("active");
		}
	});
});

function setCookie(name, value, days) {
	// Get domain without any subdomain
	let domain = window.location.hostname;

	// Make sure we're setting cookie with same attributes as original
	const expiryDate = new Date();
	expiryDate.setTime(expiryDate.getTime() + days * 24 * 60 * 60 * 1000);

	// First, try to clear any existing cookie with this name
	document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

	// Now set the new cookie with consistent attributes
	document.cookie =
		name +
		"=" +
		encodeURIComponent(value) +
		"; expires=" +
		expiryDate.toUTCString() +
		"; path=/" +
		"; SameSite=Lax";

	return document.cookie.indexOf(name + "=") >= 0;
}

// Get cookie function
function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

jQuery(document).ready(function ($) {
	// Toggle sponsoring section
	$(document).on("click", "#toggle-checkout-sponsoring", function () {
		initCustomDropdown($);
		$("#checkout-sponsoring").toggleClass("hidden");
	});

	// Initialize custom dropdown

	// Handle quick selection buttons
	$(document).on("click", ".quick-select-team", function () {
		const teamId = $(this).data("team-id");
		const teamName = $(this).data("team-name");

		// Update the dropdown selection
		const selectElement = $("#select-group-sponsor");

		// Find and select the option with matching data-value
		selectElement.find("option").each(function () {
			if ($(this).data("value") === teamId) {
				$(this).prop("selected", true);
			}
		});

		// Trigger the change event manually to activate jQuery handler
		selectElement.trigger("change");

		// Update custom dropdown display
		$(".custom-dropdown-selected span").text(teamName);

		// Highlight the selected quick button
		$(".quick-select-team")
			.removeClass("bg-black text-white")
			.addClass("bg-gray-100 text-gray-800");
		$(this)
			.removeClass("bg-gray-100 text-gray-800")
			.addClass("bg-black text-white");
	});
});

function initCustomDropdown($) {
	const selectElement = $("#select-group-sponsor");
	const customDropdownContainer = $("#custom-dropdown-container");
	const customDropdownSelected = $(".custom-dropdown-selected");
	const customDropdownMenu = $(".custom-dropdown-menu");
	const searchInput = $(".custom-dropdown-search");
	const dropdownItems = $(".dropdown-items");

	let currentFocus = -1;
	let allItems = [];

	// Populate dropdown items from select
	const options = selectElement.find("option").slice(1).get(); // Skip the "Välj lag" option
	populateDropdownItems(options);

	// Make the dropdown trigger accessible with keyboard
	customDropdownSelected.attr({
		tabindex: "0",
		role: "combobox",
		"aria-expanded": "false",
		"aria-controls": "dropdown-items",
	});

	// Toggle dropdown visibility
	customDropdownSelected.on("click", function () {
		toggleDropdown();
	});

	// Allow keyboard access to the dropdown trigger
	customDropdownSelected.on("keydown", function (e) {
		if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown") {
			e.preventDefault();
			if (customDropdownMenu.hasClass("hidden")) {
				openDropdown();
			}
		}
	});

	// Close dropdown when clicking outside
	$(document).on("click", function (event) {
		if (!$(event.target).closest(customDropdownContainer).length) {
			closeDropdown();
		}
	});

	// Handle keyboard navigation in search input
	searchInput.on("keydown", function (e) {
		handleKeyboardNavigation(e);
	});

	// Handle search functionality
	searchInput.on("input", function () {
		const searchTerm = $(this).val().toLowerCase();
		filterDropdownItems(searchTerm);
		// Reset the focus after filtering
		currentFocus = -1;
	});

	function toggleDropdown() {
		if (customDropdownMenu.hasClass("hidden")) {
			openDropdown();
		} else {
			closeDropdown();
		}
	}

	function openDropdown() {
		customDropdownMenu.removeClass("hidden");
		customDropdownSelected.attr("aria-expanded", "true");
		searchInput.focus();
		// Reset focus when opening
		currentFocus = -1;
		// Update the list of items for keyboard navigation
		allItems = dropdownItems.find(".custom-dropdown-item").get();
	}

	function closeDropdown() {
		customDropdownMenu.addClass("hidden");
		customDropdownSelected.attr("aria-expanded", "false");
		currentFocus = -1;
	}

	function populateDropdownItems(options) {
		dropdownItems.empty();
		$(options).each(function () {
			const option = $(this);
			const item = $("<div>", {
				class:
					"custom-dropdown-item p-3 cursor-pointer hover:bg-black hover:text-white transition-colors",
				"data-value": option.data("value"),
				text: option.text(),
				role: "option",
				tabindex: "-1",
			});

			item.on("click", function () {
				selectItem($(this));
			});

			dropdownItems.append(item);
		});

		// Update the list of items for keyboard navigation
		allItems = dropdownItems.find(".custom-dropdown-item").get();
	}

	function filterDropdownItems(searchTerm) {
		const filteredOptions = options.filter((option) =>
			$(option).text().toLowerCase().includes(searchTerm)
		);
		populateDropdownItems(filteredOptions);
	}

	function handleKeyboardNavigation(e) {
		// Update the list of available items
		allItems = dropdownItems.find(".custom-dropdown-item").get();

		if (allItems.length === 0) return;

		// Handle arrow up/down
		if (e.key === "ArrowDown" || e.key === "ArrowUp") {
			e.preventDefault();

			// Remove the active class from the current item
			if (currentFocus >= 0 && currentFocus < allItems.length) {
				$(allItems[currentFocus]).removeClass("bg-black text-white");
			}

			// Update focus index
			if (e.key === "ArrowDown") {
				currentFocus =
					currentFocus < allItems.length - 1 ? currentFocus + 1 : 0;
			} else {
				// ArrowUp
				currentFocus =
					currentFocus > 0 ? currentFocus - 1 : allItems.length - 1;
			}

			// Add active class to the new focused item
			if (currentFocus >= 0) {
				$(allItems[currentFocus]).addClass("bg-black text-white");
				// Scroll into view if needed
				const container = dropdownItems;
				const item = $(allItems[currentFocus]);
				const itemOffset = item.position().top;
				const itemHeight = item.outerHeight();
				const containerHeight = container.height();
				const currentScroll = container.scrollTop();

				if (itemOffset < 0) {
					// Item is above visible area
					container.scrollTop(currentScroll + itemOffset);
				} else if (itemOffset + itemHeight > containerHeight) {
					// Item is below visible area
					container.scrollTop(
						currentScroll + itemOffset - containerHeight + itemHeight
					);
				}
			}
		}
		// Handle Enter key
		else if (e.key === "Enter") {
			e.preventDefault();
			if (currentFocus >= 0 && currentFocus < allItems.length) {
				selectItem($(allItems[currentFocus]));
			}
		}
		// Handle Escape key
		else if (e.key === "Escape") {
			e.preventDefault();
			closeDropdown();
		}
	}

	function selectItem(item) {
		const selectedValue = item.data("value");
		const selectedText = item.text();

		// Update the custom dropdown display
		customDropdownSelected.find("span").text(selectedText);
		closeDropdown();

		// Update the original select element
		selectElement.find("option").each(function () {
			if ($(this).data("value") === selectedValue) {
				$(this).prop("selected", true);
				return false; // Break the loop
			}
		});

		// Deselect all quick selection buttons when selecting from dropdown
		$(".quick-select-team")
			.removeClass("bg-primary text-white")
			.addClass("bg-gray-100 text-gray-800");

		// Trigger change event on the select element to activate jQuery handler
		selectElement.trigger("change");
	}
}

// Keep the original jQuery functionality
jQuery("body").on("change", "#select-group-sponsor", function () {
	let group_id = jQuery(this).find("option:selected").data("value") ?? null;
	if (!group_id) {
		jQuery("#selected-group-container")
			.addClass("hidden")
			.find("#selected-group")
			.html("");
		return;
	}
	jQuery("input#group_id").val(group_id);
	jQuery.ajax({
		url: my_ajax_object.ajax_url,
		type: "POST",
		data: {
			action: "get_group_data",
			group_id: group_id,
		},
		success: function (response) {
			jQuery("#selected-group-container")
				.removeClass("hidden")
				.find("#selected-group")
				.html(response.data);
		},
	});
});
